import React, { useState } from 'react'
import QuizModal from './QuizModal'

const Quiz = () => {

    const[showQuizModal, setShowQuizModal] = useState(false)

    const handleClosed = ()=>{
        setShowQuizModal(false)
    }

  
    return (
        <div>
            <section>
                <div className='d-flex justify-content-center align-items-center' style={{ height: '100vh' }}>
                    <button 
                        className='btn btn-primary rounded-pill fw-bold'
                        style={{ height: '50px',  width: '150px', fontSize:"20px"}}
                        onClick={()=>{setShowQuizModal(true)}}
                    >
                        Start Quiz
                    </button>
                </div>
            </section>

            {  
              showQuizModal &&
                <QuizModal 
                    show={showQuizModal}
                    handleClose={handleClosed}
                />
            }
            
        </div>
    )
}

export default Quiz
